import axios from "axios";
// import WaterSVG from "../assets/images/SVG/water.svg";
// import PlantsSVG from "../assets/images/SVG/plants.svg";
// import FoodSVG from "../assets/images/SVG/food.svg";
// import BodySVG from "../assets/images/SVG/body.svg";
// import AnimalsSVG from "../assets/images/SVG/animals.svg";
// import FoodPNG from "../assets/images/food.png";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchSubtopics(token, topic) {
  try {
    const response = await API.post("/subtopics", { token, topic });
    // const response = {
    //   data: [
    //     { id: 1, name: "INTRODUCTION ABOUT OUR BODY 1", image: WaterSVG },
    //     { id: 2, name: "English 2", image: PlantsSVG },
    //     // { id: 3, name: "Maths 3", image: FoodSVG },
    //     // { id: 4, name: "Maths 4", image: BodySVG },
    //     // { id: 5, name: "Maths 5", image: AnimalsSVG },
    //     // { id: 6, name: "Science 6", image: WaterSVG },
    //     // { id: 7, name: "Science 7", image: WaterSVG },
    //     // { id: 8, name: "Science 8", image: FoodPNG },
    //     // { id: 9, name: "Maths 9", image: AnimalsSVG },
    //     // { id: 10, name: "Science 10", image: WaterSVG },
    //     // { id: 11, name: "Science 11", image: WaterSVG },
    //     // { id: 12, name: "Science 12", image: FoodPNG },
    //     // { id: 13, name: "Maths 13", image: AnimalsSVG },
    //     // { id: 14, name: "Science 14", image: WaterSVG },
    //     // { id: 15, name: "Science 15", image: WaterSVG },
    //     // { id: 16, name: "Science 16", image: FoodPNG },
    //     // { id: 17, name: "Maths 17", image: AnimalsSVG },
    //     // { id: 18, name: "Science 18", image: WaterSVG },
    //     // { id: 19, name: "Science 19", image: WaterSVG },
    //     // { id: 20, name: "Science 20", image: FoodPNG }
    //   ],
    // };
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchSubtopics };
